import getScheduleObj from './state';
import moment from 'moment';
import axiosService from '../../services/axios/axiosService';
import qs from 'qs';
// state object
const state = {
    schedule: getScheduleObj(),
};

// mutations are operations that actually mutates the state.
const mutations = {
    // have to clear one by one. if clear using getScheduleObj. it will mess up the pointer to the state on other pages
    resetSchedule(state: any) {
        let s = state.schedule;
        s.pickup.locationId = 0;
        s.pickup.company = null;
        s.pickup.address1 = null;
        s.pickup.address2 = null;
        s.pickup.email = null;
        s.pickup.phone = null;
        s.pickup.fax = null;
        s.pickup.timeFrom = null;
        s.pickup.timeTo = null;
        s.pickup.instructions = null;
        s.pickup.earliestPickupDate = new Date();
        s.pickup.latestPickupDate = new Date();
        s.pickup.earliestPickupTime = moment(new Date())
            .add(1, 'hour')
            .format('h:00 A');
        s.pickup.latestPickupTime = moment(new Date())
            .add(1, 'hour')
            .format('h:00 A');
        s.pickup.address_book = 0;
        s.delivery.locationId = 0;
        s.delivery.company = null;
        s.delivery.address1 = null;
        s.delivery.email = null;
        s.delivery.phone = null;
        s.delivery.fax = null;
        s.delivery.address_book = 0;
    },
};

// use actions to commit mutations
const actions = {
    resetSchedule(store: any) {
        store.commit('resetSchedule');
    },
    async saveCompany(store: any, identity: string) {
        let reqStr = qs.stringify(formAddressBookData(store, identity));
        return store.dispatch('updateCompanyWithData', reqStr);
    },
    async checkForLocation(store: any, dataString: string) {
        let request = {
            dataString,
        };

        try {
            let response = await axiosService.post(
                'https://pcmiler.alk.com/apis/rest/v1.0/Service.svc/locations?',
                request
            );
            console.log(response);
            store.commit('getLocation', response.data);
        } catch (error) {
            console.log(error);
        }
    },
};

const getters = {
    scheduleData(state: any) {
        return state.schedule;
    },
};

const schedulePickupModule = {
    state,
    mutations,
    actions,
    getters,
};

function formAddressBookData(store: any, identity: string) {
    let input = state.schedule[identity];
    let locationData = store.getters.quoteData[identity];
    let data = {
        input_client_id: input.locationId,
        input_location_address_book: 1,
        input_location_type_id: locationData.locationType,
        rec_id: 0,
        input_name: input.company,
        input_fax: input.fax,
        input_invoice_id: 0,
        input_czar_rate: 0,
        input_status: 1,
        input_phone: input.phone,
        input_email: input.email,
        input_timezone: 'PST',
        input_street: input.address1,
        input_street2: input.address2,
        input_city: locationData.city,
        input_state: locationData.state,
        input_zip: locationData.zipCode,
        input_country: 'US',
        input_lat: null,
        input_lng: null,
        input_server: 0,
        input_warehouse_id: 0,
        input_invoice_type: 'Standard',
        input_credit_score_grade: 0,
        input_netterm: 0,
        input_payment_type: 'cash',
        input_print_invoice_bol: 0,
        input_invoice_pod: 0,
        input_insurance_addl: 0,
        input_carrier_complete: 0,
        input_gps_contract: 0,
        input_watch: 0,
        input_intracompany: 0,
        input_production_line: 0,
        input_invoice_inoutgate: 0,
        input_invoice_mail: 0,
        input_email_update: -1,
        input_cust_quote: 0,
        input_customer_pickup: 0,
        input_location_notify: 0,
        input_revenue_id: 0,
        input_invoice_scale: 0,
        input_invoice_combine: 0,
        input_invoice_complete_move: 0,
        input_drop_and_hook: 0,
        input_link_terminal_id: 0,
        input_invoice_receipt: 0,
        input_dr_double_sided: 0,
        input_req_ref: 0,
        input_req_po: 0,
        input_req_do: 0,
        input_req_rate_conf: 0,
        input_cust_ref: 0,
        input_collage: 0,
        input_req_photo: 0,
        input_req_pc_count: 0,
        input_bobtail_override: 0,
        input_notify_email: 0,
        input_notify_phone: 0,
        input_notify_text: 0,
        input_notify_fax: 0,
        input_customer_group: 0,
        input_aging_format_difference: 30,
        input_statement_ref: 0,
        input_vendor: 0,
        input_accessorial_approval: 0,
        input_pu_notification: 0,
        input_dl_notification: 0,
        options_array: '[25]',
        location_shipper: 1,
        location_xml: 0,
        location_invoiceheader: 0,
        location_residential: 0,
        location_inside: 0,
        location_pickup_liftgate: 0,
        location_delivery_liftgate: 0,
        location_appointment: 0,
        location_sameday: 0,
        location_email_pod: 0,
        location_bobtail_override: 0,
        location_lh_carrier: 0,
        location_advanced_carrier: 0,
        location_beyond_carrier: 0,
        location_dray_carrier: 0,
        location_billto: 0,
        location_cfs: 0,
        location_warehouse: 0,
        location_xdock: 0,
        location_port: 0,
        location_chassisdepot: 0,
        location_parking: 0,
        location_steamship: 0,
        location_inventory: 0,
        location_vendor: 0,
        location_production_line: 0,
        pageName: 'LTL',
    };
    return data;
}

export default schedulePickupModule;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/store/schedulePickup/schedulePickupModule.ts